/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */
/**
 * Sale Cart
 */
import SalesCart from 'vcomponents/pages/account/SalesCart.vue';
import UpsellSalesCart from 'vcomponents/pages/account/UpsellSalesCart.vue';
import RenewSalesCart from 'vcomponents/pages/account/RenewSalesCart.vue';
/**
 * Renew
 */
import RenewCart from 'vcomponents/pages/account/RenewCart.vue';
import PlanRenewCart from 'vcomponents/pages/account/renew/PlanRenewCart.vue';
import ConfigurationRenewCart from 'vcomponents/pages/account/renew/ConfigurationRenewCart.vue';
import LicencesDistributionRenewCart from 'vcomponents/pages/account/renew/LicencesDistributionRenewCart.vue';
import RenewConfirmed from 'vcomponents/pages/subscription/RenewConfirmed.vue';
/**
 * New
 */
import ClientCart from 'vcomponents/pages/account/ClientCart.vue';
import PlanCart from 'vcomponents/pages/account/client/PlanCart.vue';
import ConfigurationCart from 'vcomponents/pages/account/client/ConfigurationCart.vue';
import PaymentConfirmed from 'vcomponents/pages/subscription/PaymentConfirmed.vue';
/**
 * Upsell
 */
import UpsellCart from 'vcomponents/pages/account/UpsellCart.vue';
import PlanUpsellCart from 'vcomponents/pages/account/upsell/PlanUpsellCart.vue';
import ConfigurationUpsellCart from 'vcomponents/pages/account/upsell/ConfigurationUpsellCart.vue';
import UpsellConfirmed from 'vcomponents/pages/subscription/UpsellConfirmed.vue';

import PaymentCart from 'vcomponents/pages/account/client/PaymentCart.vue';

/**
 * Chargebee SelfService
 */
import ChargebeeUpsellCart from 'vcomponents/pages/account/upsell/ChargebeeUpsellCart.vue';

export default [
    {
        path: '/subscription/cart',
        name: 'sam.selfservice.cart.form',
    },
    {
        path: '/subscription/checkout/{id}',
        name: 'sam.selfservice.cart.checkout',
    },
    {
        path: '/v4/subscription/checkout/{id}',
        name: 'sam.v4.selfservice.cart.checkout',
    },
    {
        path: '/sam-cart/new/{id}',
        name: 'sam.cart.form',
    },
    {
        path: '/sam-cart/new/:id',
        name: 'sam.cart.form.legacy',
    },

    // Cart v4 config

    // Sales Cart
    {
        path: '/sam-cart/v4/sale/:id/:thirdId/:customerId',
        name: 'sam.v4.cart.form',
        component: SalesCart,
        meta: {
            user_context: 'edit',
        },
    },
    {
        path: '/sam-cart/v4/sale/upsell/:id/:corpId/:thirdId/:customerId',
        name: 'sam.v4.upsell.cart.form',
        component: UpsellSalesCart,
        meta: {
            user_context: 'edit',
        },
    },
    {
        path: '/sam-cart/v4/sale/renew/:id/:corpId/:thirdId/:customerId',
        name: 'sam.v4.sale.renew.cart.form',
        component: RenewSalesCart,
        meta: {
            user_context: 'edit',
        },
    },
    // Client Cart
    /**
     * :upsellCartId : 'new' | upsell Cart id
     */
    {
        path: '/sam-cart/v4/client/upsell/:upsellCartId',
        name: 'sam.v4.client.upsell.form',
        component: UpsellCart,
        children: [
            {
                path: 'plan',
                name: 'sam.v4.client.upsell.form.plan',
                component: PlanUpsellCart,
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'configuration',
                name: 'sam.v4.client.upsell.form.configuration',
                component: ConfigurationUpsellCart,
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'payment',
                name: 'sam.v4.client.upsell.form.payment',
                component: PaymentCart,
                meta: {
                    user_context: 'edit',
                },
            },
        ],
    },
    /**
     * :id : 'new' | cartId
     */
    {
        path: '/sam-cart/v4/client/:id',
        name: 'sam.v4.client.form',
        component: ClientCart,
        children: [
            {
                path: 'plan',
                name: 'sam.v4.client.form.plan',
                component: PlanCart,
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'configuration',
                name: 'sam.v4.client.form.configuration',
                component: ConfigurationCart,
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'payment',
                name: 'sam.v4.client.form.payment',
                component: PaymentCart,
                meta: {
                    user_context: 'edit',
                },
            },
        ],
    },
    /**
     * :renewCartId : 'new' | renew Cart id
     */
    {
        path: '/sam-cart/v4/client/renew/:renewCartId',
        name: 'sam.v4.client.renew.form',
        component: RenewCart,
        children: [
            {
                path: 'plan',
                name: 'sam.v4.client.renew.form.plan',
                components: {
                    routerCart: PlanRenewCart,
                },
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'configuration',
                name: 'sam.v4.client.renew.form.configuration',
                components: {
                    routerCart: ConfigurationRenewCart,
                },
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'licences',
                name: 'sam.v4.client.renew.form.licences',
                components: {
                    routerCart: LicencesDistributionRenewCart,
                },
                meta: {
                    user_context: 'edit',
                },
            },
            {
                path: 'payment',
                name: 'sam.v4.client.renew.form.payment',
                components: {
                    routerCart: PaymentCart,
                },
                meta: {
                    user_context: 'edit',
                },
            },
        ],
    },
    {
        path: '/subscription/payment-confirmed',
        name: 'sam.subscription.payment-confirmed',
        component: PaymentConfirmed,
        props: true,
    },
    {
        path: '/subscription/upsell/payment-confirmed',
        name: 'sam.upsell.payment-confirmed',
        component: UpsellConfirmed,
        props: true,
    },
    {
        path: '/subscription/renew/payment-confirmed',
        name: 'sam.renew.payment-confirmed',
        component: RenewConfirmed,
        props: true,
    },
    // Chargebee
    {
        name: 'chargebee.upsell.cart',
        path: '/upsell/cart',
        component: ChargebeeUpsellCart,
    },
];
